import { Component, OnInit, ChangeDetectorRef, Input, AfterContentChecked, ViewChild, OnDestroy } from '@angular/core';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { CreativePerformanceV1Component } from '../creative-performace-v1/creative-performance-v1.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { CreativePerformance, VideoCompletionPercentage } from '../creative-detail-v2/creative-detail.interface';
import { NguCarousel } from '@ngu/carousel';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import * as jQuery from 'jquery';
import * as _ from 'underscore';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS, FILE_MEDIA_TYPES } from '../../../analytics/constants/analytics.constants';

interface IMediaFile {
	type: string;
	url: string;
	width: number;
	height: number;
}
@Component({
	selector: 'app-performace-creative-v6',
	templateUrl: './performace-creative-v6.component.html',
	styleUrls: ['./performace-creative-v6.component.css']
})
export class PerformaceCreativeV6Component
	extends CreativePerformanceV1Component
	implements OnInit, AfterContentChecked, OnDestroy
{
	@Input() placeholderimage: any;
	@Input() producttype: string;
	public isDisplay: Boolean;
	public isPreroll: Boolean;
	public isDOOH: Boolean;
	public isDOOHDisplay: Boolean;
	public isDOOHVideo: Boolean;
	public isGeofence: Boolean;
	public isGeovideo: Boolean;
	public isSem: Boolean;
	public isCTV: Boolean;
	public isSocial: Boolean;
	public isVideo: Boolean;
	public isRadio: boolean;
	public isGam: boolean;
	public isCreativeArrow: Boolean;
	public downloadConfiguration: DownloadConfig;
	public currentIndex = 0;
	public displayIndex = 0;
	public columns: any;
	public downloadCSVColumns: any;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrow: true,
		duration: 750,
		scale: 'big',
		dynamicTitle: true,
		theme: 'light r6-video-creatives'
	};
	public showEngagemetsStats: boolean = false;
	public youtubeViewsPermission: boolean = false;
	public placeholderImage: string = '/assets/images/no-creative-preview-r2.png';
	public isR6: boolean = false;
	public isR104: boolean = false;
	@ViewChild('carousel') carousel: NguCarousel<any>;
	public creatives: any;
	@Input() legend: any;
	@Input() downloadconfig: any;
	@Input() columnsconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() sectionclass: string;
	@Input() uniqueoverwriteid: string;
	public range: string;
	semGoLiveDate: any;
	isGoliveNotStarted: boolean;
	isCutoffDate: boolean;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected modalService: ModalService,
		cdr: ChangeDetectorRef,
		protected sanitizer: DomSanitizer
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			if (this.isSem || this.isRadio) {
				this.requestSEMData();
			} else {
				this.requestData();
				const displayObjects = this.legend.filter((legendObj) => legendObj.displayName === 'Ad Interactions');
			}
		});
	}

	ngOnInit() {
		this.isDisplay = this.analyticsDataModel.getCurrentPath() === PATHS.DISPLAY;
		this.isPreroll = this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL;
		this.isDOOH = this.analyticsDataModel.getCurrentPath() === PATHS.DOOH;
		this.isDOOHDisplay = this.sectionclass === 'dooh-display';
		this.isDOOHVideo = this.sectionclass === 'dooh-preroll r6-dooh-preroll';
		this.isSocial = this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL;
		this.isGeofence = this.analyticsDataModel.getCurrentPath() === PATHS.GEOFENCE;
		this.isGeovideo = this.analyticsDataModel.getCurrentPath() === PATHS.GEOVIDEO;
		this.isSem = this.analyticsDataModel.getCurrentPath() === PATHS.SEM;
		this.isCTV = this.analyticsDataModel.getCurrentPath() === PATHS.CTV;
		this.isRadio = this.analyticsDataModel.getCurrentPath() === PATHS.RADIO;
		this.isGam = this.analyticsDataModel.getCurrentPath() === PATHS.GAM;
		this.isR6 = this.analyticsDataModel.config.version.toUpperCase() == 'R6' ? true : false;
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.columns = this.columnsconfig ? JSON.parse(decodeURI(this.columnsconfig)) : [];
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.legend = JSON.parse(decodeURI(this.legend));
		this.legend = _.filter(this.legend, (item) => {
			return this.analyticsDataModel.checkComponentForPermission(item);
		});
		this.youtubeViewsPermission =
			_.filter(this.legend, (item) => {
				return item['displayName'] === 'Youtube Views';
			}).length > 0
				? true
				: false;
		if (this.isSem || this.isRadio) {
			this.requestSEMData();
		} else {
			super.ngOnInit();
			const displayObjects = this.legend.filter((legendObj) => legendObj.displayName === 'Ad Interactions');
		}
		this.placeholderImage =
			this.placeholderimage || this.placeholderimage !== '' ? this.placeholderimage : this.placeholderImage;
	}

	ngAfterContentChecked() {
		if (jQuery('.prerollVideo').length) {
			_.each(jQuery('.prerollVideo'), function (video, index) {
				jQuery('#preRollvideo' + index).bind('ended', function () {
					jQuery('#pauseBtn' + index).hide();
					jQuery('#playBtn' + index).show();
				});
			});
		}
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		this.selectedCreative = undefined;
	}

	openModal(id: string, creative: CreativePerformance): void {
		if (!this.selectedCreative) {
			this.selectedCreative = creative;
		}
		setTimeout(() => {
			this.modalService.open(id);
		}, 100);
	}

	closeModal(id: string) {
		this.modalService.close(id);
		this.selectedCreative = undefined;
	}

	requestData(): void {
		if (this.isSem) {
			this.requestSEMData();
		} else {
			super.requestData();
			const displayObjects = this.legend.filter((legendObj) => legendObj.displayName === 'Ad Interactions');
		}
	}

	requestSEMData() {
		this.hasGraphData = false;
		this.showLoad = true;
		this.hasData = true;
		this.analyticsService.checkDateRange();
		this.isGoliveNotStarted = this.analyticsService.isGoliveNotStarted;
		this.isCutoffDate = this.analyticsService.isCutoffDate;
		this.analyticsService.processWidgetRequest(this.key, this.columns).subscribe((response: any) => {
			this.showLoad = false;
			response.data && response.data.length > 1 ? (this.isCreativeArrow = true) : (this.isCreativeArrow = false);
			if (response.success) {
				this.hasData = true;
				this.responseData = response.data;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(responseData) {
		responseData.length > 1 ? (this.isCreativeArrow = true) : (this.isCreativeArrow = false);
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
			this.isVideo = this.creatives[0].videoCompletionPercentage
				? Boolean(parseFloat(this.creatives[0].videoCompletionPercentage.quarter))
				: false;
			const videoCreatives = _.where(this.creatives, { isVideoCreative: true });
			this.isVideoCreative = videoCreatives.length > 0;
			this.hasGraphData = true;
		} else {
			this.hasData = false;
		}
	}

	mapResponseDataToInterface(responseData) {
		const creativePerformances: CreativePerformance[] = [];
		for (const response of responseData) {
			const creativeObj: CreativePerformance = {} as CreativePerformance;
			const siteLinksArr = [];
			let siteLinks = [];
			let location = '';
			let locationObj = {};
			const calloutsExtnArr = [];
			let calloutsExtn = [];
			const structuredSnippetExtnArr = [];
			let structuredSnippetExtn = [];
			creativeObj.creativeName = response.creative_name ? response.creative_name : response.ad_headline;
			creativeObj.creativeName = creativeObj.creativeName ? creativeObj.creativeName : response.name;
			creativeObj.versionId = UtilityService.isUndefinedOrNull(response.cup_version_id)
				? 0
				: parseFloat(response.cup_version_id);
			creativeObj.clicks = UtilityService.isUndefinedOrNull(response.clicks) ? 0 : parseFloat(response.clicks);
			creativeObj.iframeUrl = UtilityService.isUndefinedOrNull(response.iframe_url) ? null : response.iframe_url;
			creativeObj.isIframeExpired = response.is_iframe_expired === 0 ? false : true;
			creativeObj.hasSnapshotImage = response.snapshot_path ? true : false;
			creativeObj.snapshotImage = creativeObj.hasSnapshotImage ? response.snapshot_path : null;
			creativeObj.clickRate = UtilityService.isUndefinedOrNull(response.click_rate)
				? UtilityService.isUndefinedOrNull(response.clickthroughrate)
					? 0
					: response.clickthroughrate
				: response.click_rate;
			creativeObj.adInteractions = UtilityService.isUndefinedOrNull(response.ad_interactions)
				? 0
				: parseFloat(response.ad_interactions);
			creativeObj.adInteractionRate = UtilityService.isUndefinedOrNull(response.interaction_rate)
				? 0
				: parseFloat(response.interaction_rate);
			creativeObj.impressions = UtilityService.isUndefinedOrNull(response.impressions)
				? 0
				: parseFloat(response.impressions);
			creativeObj.isIAB = UtilityService.isUndefinedOrNull(response.isIAB)
				? false
				: Number(response.isIAB)
				? true
				: false;
			creativeObj.isNative = UtilityService.isUndefinedOrNull(response.isNative)
				? false
				: Number(response.isNative)
				? true
				: false;
			creativeObj.native = response.native;
			// TODO: Change logic on figuring out if creative is ctv or preroll
			creativeObj.isCtv = this.sectiontitle.indexOf('Connected TV') !== -1;
			creativeObj.adHeadline = UtilityService.isUndefinedOrNull(response.ad_headline) ? '' : response.ad_headline;
			creativeObj.impressions = parseFloat(response.impressions);
			creativeObj.avgPosition = parseFloat(response.avg_position);
			creativeObj.absTopImpression = parseFloat(response.abs_top_impression_share);
			creativeObj.topImpression = parseFloat(response.top_impression_share);
			creativeObj.description = response.description;
			creativeObj.callExtension = response && response.call_extn ? JSON.parse(response.call_extn)[0][1] : '';
			if (response.callouts_extn) {
				calloutsExtn = JSON.parse(response.callouts_extn);
				for (const item of calloutsExtn) {
					calloutsExtnArr.push(item['1']);
				}
			}
			if (response.structuredsnippet_extn) {
				structuredSnippetExtn = JSON.parse(response.structuredsnippet_extn);
				for (const item of structuredSnippetExtn) {
					structuredSnippetExtnArr.push({
						type: item['1'],
						value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] != '' ? item['2'].join(', ') : item['2']
					});
				}
			}
			if (response.sitelink_extn) {
				siteLinks = JSON.parse(response.sitelink_extn);
				for (const item of siteLinks) {
					siteLinksArr.push({
						heading: item['1'],
						description: (item['3'] || '') + ' ' + (item['4'] || ''),
						link: Array.isArray(item['5']) ? item['5'][0] : item['5']
					});
				}
			}
			if (response.location_extn) {
				locationObj = JSON.parse(response.location_extn)[0];
				let locationArr = [];
				for (var prop in locationObj) {
					if (parseInt(prop) > 1 && parseInt(prop) < 8) {
						locationArr.push(locationObj[prop]);
					}
				}
				location = locationArr.join(', ');
				creativeObj.location = location;
			}
			creativeObj.siteLinks = siteLinksArr;
			creativeObj.structuredSnippetExtn = structuredSnippetExtnArr;
			creativeObj.calloutsExtn = calloutsExtnArr.length > 0 ? calloutsExtnArr : [];
			creativeObj.isVideoCreative =
				!UtilityService.isUndefinedOrNull(response.video_url) || response.is_video_creative == 'video' ? true : false;
			if (this.isSocial) {
				creativeObj.creativeThumbnail =
					response.creative_thumbnail_image && response.creative_thumbnail_image !== ''
						? decodeURIComponent(
								response.creative_thumbnail_image.slice(
									response.creative_thumbnail_image.includes('http')
										? response.creative_thumbnail_image.lastIndexOf('http')
										: 0
								)
						  )
						: null;
				UtilityService.checkImageURLExpired(creativeObj.creativeThumbnail).then((exists) => {
					if (!exists) {
						creativeObj.creativeThumbnail = null;
					}
				});
			} else {
				creativeObj.creativeThumbnail = !UtilityService.isUndefinedOrNull(response.thumbnail)
					? !UtilityService.checkEncodeURI(response.thumbnail)
						? encodeURI(response.thumbnail)
						: response.thumbnail
					: !UtilityService.isUndefinedOrNull(response.creative_thumbnail_image)
					? !UtilityService.checkEncodeURI(response.creative_thumbnail_image)
						? encodeURI(response.creative_thumbnail_image)
						: response.creative_thumbnail_image
					: this.placeholderImage;
			}
			creativeObj.creativeThumbnail =
				creativeObj.creativeThumbnail && creativeObj.creativeThumbnail != 'null'
					? `'${creativeObj.creativeThumbnail}'`
					: creativeObj.creativeThumbnail;
			if (creativeObj.isVideoCreative || !UtilityService.isUndefinedOrNull(response['25_percent_rate'])) {
				creativeObj.creativeVideo = response.video_url;
				creativeObj.completionRate = UtilityService.isUndefinedOrNull(response['100_percent_rate'])
					? 0
					: parseFloat(response['100_percent_rate']).toFixed(2);
				creativeObj.completions = UtilityService.isUndefinedOrNull(response['100_percent_value'])
					? 0
					: parseInt(response['100_percent_value'], 10);

				let videoCompletionPercentage: VideoCompletionPercentage = <VideoCompletionPercentage>{};
				videoCompletionPercentage.started = 100;
				videoCompletionPercentage.completed = UtilityService.isUndefinedOrNull(response['100_percent_rate'])
					? 0
					: parseFloat(response['100_percent_rate']).toFixed(2);
				videoCompletionPercentage.completionValue = UtilityService.isUndefinedOrNull(response['100_percent_value'])
					? 0
					: parseInt(response['100_percent_value'], 10);
				videoCompletionPercentage.quarter = UtilityService.isUndefinedOrNull(response['25_percent_rate'])
					? 0
					: parseFloat(response['25_percent_rate']).toFixed(2);
				videoCompletionPercentage.quarterValue = UtilityService.isUndefinedOrNull(response['25_percent_value'])
					? 0
					: parseInt(response['25_percent_value'], 10);
				videoCompletionPercentage.halfValue = UtilityService.isUndefinedOrNull(response['50_percent_value'])
					? 0
					: parseInt(response['50_percent_value'], 10);
				videoCompletionPercentage.half = UtilityService.isUndefinedOrNull(response['50_percent_rate'])
					? 0
					: parseFloat(response['50_percent_rate']).toFixed(2);
				videoCompletionPercentage.threeQuarters = UtilityService.isUndefinedOrNull(response['75_percent_rate'])
					? 0
					: parseFloat(response['75_percent_rate']).toFixed(2);
				videoCompletionPercentage.threeQuartersValue = UtilityService.isUndefinedOrNull(response['75_percent_value'])
					? 0
					: parseInt(response['75_percent_value'], 10);
				// videoCompletionPercentage = this.addVideoCompletionTooltip(videoCompletionPercentage);
				creativeObj.videoCompletionPercentage = videoCompletionPercentage;
			}
			if (response.creatives_by_ads) {
				creativeObj.adSizes = this.mapResponseToAdSizes(response.creatives_by_ads ? response.creatives_by_ads : []);
				creativeObj.hasAdSizes = !creativeObj.isVideoCreative ? !!response.creatives_by_ads : false;
			}
			if (response.creatives_by_date) {
				creativeObj.creativeStats = this.mapResponseToCreativeStats(response.creatives_by_date);
			}
			if (response.url) {
				try {
					creativeObj.url = JSON.parse(response.url)[0];
				} catch (e) {
					creativeObj.url = response.url;
				}
			}
			creativeObj.graphData = this.generateGraphDataByCreative(creativeObj.creativeStats);
			creativeObj.audioURL = response.audio_url ? response.audio_url : undefined;
			creativeObj.engagements = UtilityService.isUndefinedOrNull(response.engagements)
				? 0
				: parseFloat(response.engagements);
			creativeObj.comments = UtilityService.isUndefinedOrNull(response.comments) ? 0 : parseFloat(response.comments);
			creativeObj.likes = UtilityService.isUndefinedOrNull(response.likes) ? 0 : parseFloat(response.likes);
			creativeObj.saves = UtilityService.isUndefinedOrNull(response.saves) ? 0 : parseFloat(response.saves);
			creativeObj.reactions = UtilityService.isUndefinedOrNull(response.reactions) ? 0 : parseFloat(response.reactions);
			creativeObj.shares = UtilityService.isUndefinedOrNull(response.shares) ? 0 : parseFloat(response.shares);
			creativeObj.youtubeviews = UtilityService.isUndefinedOrNull(response.youtube_verified_imprs)
				? 0
				: parseFloat(response.youtube_verified_imprs);
			creativeObj.youtubeviewsrate = UtilityService.isUndefinedOrNull(response.youtube_verified_imprs_rate)
				? 0
				: parseFloat(response.youtube_verified_imprs_rate);
			if (this.isDOOH) {
				let setMp4Link = response.mp4;
				let isNonManagedVideo = response.fetch_direct_video == '1' ? true : false;
				const setMediaFiles = response.media_files;
				if (setMp4Link === null || setMp4Link === '') {
					setMp4Link = isNonManagedVideo ? setMediaFiles : this.getMp4FromMediaFilesJson(setMediaFiles);
				}
				creativeObj.setMp4Link = setMp4Link;
			}
			creativePerformances.push(creativeObj);
		}
		return creativePerformances;
	}
	getMp4FromMediaFilesJson(mediaFilesJson: string) {
		let mp4Link: string = null;

		let decodedMediaFiles: Array<IMediaFile>;
		let isJsonDecodeSuccess = false;
		try {
			decodedMediaFiles = JSON.parse(mediaFilesJson);
			isJsonDecodeSuccess = true;
		} catch (e) {
			isJsonDecodeSuccess = false;
		}

		if (isJsonDecodeSuccess && decodedMediaFiles) {
			let fallBackMediaFile: IMediaFile;
			for (const mediaFile of decodedMediaFiles) {
				if (mediaFile.type === FILE_MEDIA_TYPES.MP4) {
					if (mediaFile.width === 640 && mediaFile.height === 360) {
						mp4Link = mediaFile.url;
						break;
					} else {
						if (fallBackMediaFile) {
							if (fallBackMediaFile.width > mediaFile.width && mediaFile.width >= 640) {
								fallBackMediaFile = mediaFile;
							}
						} else {
							fallBackMediaFile = mediaFile;
						}
					}
				}
			}

			if ((mp4Link === null || mp4Link === '') && fallBackMediaFile) {
				mp4Link = fallBackMediaFile.url;
			}
		}

		return mp4Link;
	}

	downloadCSV() {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}

	playclickEvent(i) {
		this.currentIndex = i;
		_.each(jQuery('.playVideo'), (icons, index) => {
			jQuery('#playBtn' + index).hide();
			jQuery('#pauseBtn' + index).hide();
		});
		jQuery('#pauseBtn' + i).show();
		jQuery('#preRollvideo' + i)[0].play();
	}

	pauseclickEvent(i) {
		this.currentIndex = i;
		_.each(jQuery('.playVideo'), (icons, index) => {
			jQuery('#playBtn' + index).hide();
			jQuery('#pauseBtn' + index).hide();
		});
		jQuery('#playBtn' + i).show();
		jQuery('#preRollvideo' + i)[0].pause();
	}

	volumeclick(i) {
		this.currentIndex = i;
		_.each(jQuery('.volumeControlIcon'), (icons, index) => {
			jQuery('#muteBtn' + index).hide();
			jQuery('#volumeBtn' + index).hide();
		});
		jQuery('#volumeBtn' + i).show();
		jQuery('#preRollvideo' + i)[0].muted = false;
	}
	moveToNext(index) {
		this.isVideo = this.creatives[index].videoCompletionPercentage
			? Boolean(parseInt(this.creatives[index].videoCompletionPercentage.quarter))
			: false;
		this.currentIndex = index;
		this.displayIndex = index;
		this.carousel.moveTo(index, false);
	}
	muteclick(i) {
		this.currentIndex = i;
		_.each(jQuery('.volumeControlIcon'), (icons, index) => {
			jQuery('#muteBtn' + index).hide();
			jQuery('#volumeBtn' + index).hide();
		});
		jQuery('#muteBtn' + i).show();
		jQuery('#preRollvideo' + i)[0].muted = true;
	}

	onmoveFn(event) {
		_.each(jQuery('.prerollVideo'), (video, index) => {
			jQuery('#preRollvideo' + index)[0].pause();
			jQuery('#preRollvideo' + index)[0].muted = true;
			jQuery('#playBtn' + index).hide();
			jQuery('#pauseBtn' + index).hide();
			jQuery('#muteBtn' + index).show();
			jQuery('#volumeBtn' + index).hide();
		});
		if (jQuery('#preRollvideo' + this.currentIndex)[0]) {
			jQuery('#preRollvideo' + this.currentIndex)[0].play();
			jQuery('#pauseBtn' + this.currentIndex).show();
			jQuery('#muteBtn' + this.currentIndex).show();
		}
		_.each(jQuery('.audioCreative'), (audio, index) => {
			const audioCreative: HTMLMediaElement = audio as HTMLMediaElement;
			audioCreative.muted = true;
			audioCreative.pause();
			if (event.currentSlide === index) {
				audioCreative.currentTime = 0;
				audioCreative.muted = false;
			}
		});
	}

	getCreativeSize(thumbnail) {
		if (this.isR6) {
			if (thumbnail?.includes('468x60') || thumbnail?.includes('300x50')) {
				return '100% 30%';
			} else if (thumbnail?.includes('300x600')) {
				return 'auto 100%';
			} else if (thumbnail?.includes('160x600')) {
				return 'auto 100%';
			} else if (thumbnail?.includes('320x50')) {
				return '100% auto';
			} else if (thumbnail?.includes('728x90')) {
				return '100% auto';
			} else {
				return '100% 100%';
			}
		} else {
			if (
				thumbnail?.includes('728x90') ||
				thumbnail?.includes('468x60') ||
				thumbnail?.includes('320x50') ||
				thumbnail?.includes('300x50')
			) {
				return '100% 30%';
			} else if (thumbnail?.includes('300x600')) {
				return '75% 100%';
			} else if (thumbnail?.includes('160x600')) {
				return '40% 100%';
			} else {
				return '100% 100%';
			}
		}
	}

	nextArrow() {
		if (this.creatives.length > 1) {
			if (0 === this.displayIndex) {
				this.displayIndex = this.creatives.length - 1;
			} else {
				this.displayIndex = this.displayIndex - 1;
			}
			this.currentIndex = this.displayIndex;
			this.carousel.moveTo(this.displayIndex, false);
		}
		this.showEngagemetsStats = false;
	}

	prevArrow() {
		if (this.creatives.length > 1) {
			if (this.creatives.length - 1 === this.displayIndex) {
				this.displayIndex = 0;
			} else {
				this.displayIndex = this.displayIndex + 1;
			}
			this.currentIndex = this.displayIndex;
			this.carousel.moveTo(this.displayIndex, false);
		}
		this.showEngagemetsStats = false;
	}

	formatValuesForComma(value) {
		return Number(value).toLocaleString('en-GB');
	}
}
